import { render, staticRenderFns } from "./InnerShadowTIcon.vue?vue&type=template&id=2783510a&"
import script from "./InnerShadowTIcon.vue?vue&type=script&lang=js&"
export * from "./InnerShadowTIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports